var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{attrs:{"aria-label":_vm.$t(_vm.label)},on:{"click":function($event){$event.preventDefault();return _vm.searchCategory()}}},[_vm._v(" "+_vm._s(_vm.$t(_vm.label))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }